/* hrs-fitment.js
 * Year/Make/Model/Trim fitment selector for HiRev Sports.
 * - Cascading dropdowns sourced from #hrs-vehicle-catalog
 * - Evaluates against product fitment (custom.fitment list "YEAR|MAKE|MODEL|TRIM")
 * - Persists chosen vehicle in localStorage (hrs_vehicle), 90-day expiry
 * - Soft gate: never disables ATC; warns + redirects on mismatch
 * - Fires analytics events on window dataLayer + Shopify analytics if present
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hrs_vehicle';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

  function norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }

  function track(name, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
    } catch (e) {}
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
        window.ShopifyAnalytics.lib.track(name, payload || {});
      }
    } catch (e) {}
  }

  function readSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.ts || (Date.now() - v.ts) > MAX_AGE_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return v;
    } catch (e) { return null; }
  }

  function saveVehicle(v) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        year: v.year, make: v.make, model: v.model, trim: v.trim || '', ts: Date.now()
      }));
    } catch (e) {}
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildOption(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function resetSelect(sel, placeholder) {
    sel.innerHTML = '';
    sel.appendChild(buildOption('', placeholder));
    sel.disabled = true;
  }

  function init(root) {
    var catalog = parseJSON(root.querySelector('#hrs-vehicle-catalog'));
    var fitmentRaw = parseJSON(root.querySelector('[data-hrs-product-fitment]'));
    var fitment = Array.isArray(fitmentRaw) ? fitmentRaw : (fitmentRaw ? [fitmentRaw] : []);

    if (!catalog) return;

    var selYear = root.querySelector('[data-hrs-select="year"]');
    var selMake = root.querySelector('[data-hrs-select="make"]');
    var selModel = root.querySelector('[data-hrs-select="model"]');
    var selTrim = root.querySelector('[data-hrs-select="trim"]');
    var title = root.querySelector('[data-hrs-fitment-title]');
    var resFit = root.querySelector('[data-hrs-result="fit"]');
    var resNo = root.querySelector('[data-hrs-result="nofit"]');
    var resetBtn = root.querySelector('[data-hrs-reset]');
    var findLink = root.querySelector('[data-hrs-find]');

    // ---- Build the cross-make year list ----
    var yearsSet = {};
    Object.keys(catalog).forEach(function (mk) {
      Object.keys(catalog[mk]).forEach(function (md) {
        (catalog[mk][md].years || []).forEach(function (y) { yearsSet[y] = true; });
      });
    });
    Object.keys(yearsSet).map(Number).sort(function (a, b) { return b - a; })
      .forEach(function (y) { selYear.appendChild(buildOption(String(y), String(y))); });

    function makesForYear(year) {
      return Object.keys(catalog).filter(function (mk) {
        return Object.keys(catalog[mk]).some(function (md) {
          return (catalog[mk][md].years || []).indexOf(Number(year)) > -1;
        });
      });
    }
    function modelsFor(year, make) {
      if (!catalog[make]) return [];
      return Object.keys(catalog[make]).filter(function (md) {
        return (catalog[make][md].years || []).indexOf(Number(year)) > -1;
      });
    }
    function trimsFor(make, model) {
      return (catalog[make] && catalog[make][model] && catalog[make][model].trims) || [];
    }

    function evaluate() {
      var sel = {
        year: norm(selYear.value),
        make: norm(selMake.value),
        model: norm(selModel.value),
        trim: norm(selTrim.value)
      };
      hideResults();
      if (!sel.year || !sel.make || !sel.model) { return; }

      var fits = fitment.some(function (row) {
        var p = String(row).split('|');
        var y = norm(p[0]), mk = norm(p[1]), md = norm(p[2]), tr = norm(p[3]);
        return y === sel.year && mk === sel.make && md === sel.model &&
               (tr === '*' || tr === '' || tr === sel.trim || !sel.trim);
      });

      var label = selYear.value + ' ' + selMake.value + ' ' + selModel.value;
      saveVehicle({ year: selYear.value, make: selMake.value, model: selModel.value, trim: selTrim.value });
      resetBtn.hidden = false;

      if (fits) {
        showFit(label);
        track('fitment_confirmed', { vehicle: label, handle: root.dataset.productHandle });
      } else {
        showNoFit(label);
        track('fitment_mismatch', { vehicle: label, handle: root.dataset.productHandle });
      }
    }

    function showFit(label) {
      resNo.hidden = true; resNo.classList.remove('is-visible');
      resFit.hidden = false; resFit.classList.add('is-visible');
      resFit.querySelector('[data-hrs-result-text]').textContent = 'Fits your ' + label;
      title.textContent = 'Fitment confirmed';
    }
    function showNoFit(label) {
      resFit.hidden = true; resFit.classList.remove('is-visible');
      resNo.hidden = false; resNo.classList.add('is-visible');
      resNo.querySelector('[data-hrs-result-text]').textContent =
        "This part isn't listed to fit your " + label + '.';
      // Point "find parts" at a search for their vehicle
      var q = encodeURIComponent(label);
      findLink.setAttribute('href', '/search?q=' + q + '&type=product');
      title.textContent = 'Check fitment';
    }
    function hideResults() {
      resFit.hidden = true; resFit.classList.remove('is-visible');
      resNo.hidden = true; resNo.classList.remove('is-visible');
    }

    // ---- Cascade wiring ----
    selYear.addEventListener('change', function () {
      resetSelect(selMake, 'Make'); resetSelect(selModel, 'Model'); resetSelect(selTrim, 'Trim (optional)');
      if (!selYear.value) { hideResults(); return; }
      makesForYear(selYear.value).forEach(function (mk) { selMake.appendChild(buildOption(mk, mk)); });
      selMake.disabled = false;
      hideResults();
    });
    selMake.addEventListener('change', function () {
      resetSelect(selModel, 'Model'); resetSelect(selTrim, 'Trim (optional)');
      if (!selMake.value) return;
      modelsFor(selYear.value, selMake.value).forEach(function (md) { selModel.appendChild(buildOption(md, md)); });
      selModel.disabled = false;
      hideResults();
    });
    selModel.addEventListener('change', function () {
      resetSelect(selTrim, 'Trim (optional)');
      if (!selModel.value) return;
      var trims = trimsFor(selMake.value, selModel.value);
      if (trims.length) { trims.forEach(function (t) { selTrim.appendChild(buildOption(t, t)); }); selTrim.disabled = false; }
      evaluate(); // trim optional — evaluate on model select
    });
    selTrim.addEventListener('change', evaluate);

    resetBtn.addEventListener('click', function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      selYear.value = '';
      resetSelect(selMake, 'Make'); resetSelect(selModel, 'Model'); resetSelect(selTrim, 'Trim (optional)');
      hideResults();
      title.textContent = 'Select your vehicle to confirm fitment';
      resetBtn.hidden = true;
    });

    // ---- Restore saved vehicle (state D) ----
    var saved = readSaved();
    if (saved && saved.year) {
      selYear.value = String(saved.year);
      selYear.dispatchEvent(new Event('change'));
      if (saved.make) { selMake.value = saved.make; selMake.dispatchEvent(new Event('change')); }
      if (saved.model) { selModel.value = saved.model; selModel.dispatchEvent(new Event('change')); }
      if (saved.trim) { selTrim.value = saved.trim; }
      evaluate();
    }

    track('fitment_selector_opened', { handle: root.dataset.productHandle });
  }

  function boot() {
    document.querySelectorAll('[data-hrs-fitment]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
